import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { IoCall } from "react-icons/io5";
import { TfiEmail } from "react-icons/tfi";
import { IoArrowUpCircleOutline } from "react-icons/io5";
import { FaLocationDot } from 'react-icons/fa6';
import { MdCall } from 'react-icons/md';
import PadampuraTemple from '../images/PadampuraTemple.jpg';

export default function Contact() {
  const [contData, setcontData] = useState(null);
  const [nearByData, setnearByData] = useState([]);
  const [loader, setloader] = useState(false);

  const getContactDtl = () => {
    const requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    fetch("https://api.padampura.com/ContactUs", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === true) {
          setcontData(result.data);
        } else {
          console.warn("No contact data found.");
        }
      })
      .catch((error) => console.error("Fetch error (ContactUs):", error));
  };

  const nearByList = () => {
    setloader(true);
    const requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    fetch("https://api.padampura.com/NearByList", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === true) {
          setnearByData(result.data);
        } else {
          console.warn("No nearby data found.");
        }
      })
      .catch((error) => console.error("Fetch error (NearByList):", error))
      .finally(() => setloader(false));
  };

  useEffect(() => {
    getContactDtl();
    nearByList();
    // Scroll to top on mount
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const sanitizeHtml = (html) => {
    return html ? html.replace(/<\/?p>/g, '').trim() : '';
  };

  // Split text by newline and filter empty lines
  const splitLines = (text) => {
    return text?.split(/\r?\n/).filter(line => line.trim()) || [];
  };

  return (
    <div>
      <Helmet>
        <title>Contact Us | Padampura Temple</title>
        <meta name="description" content="Get in touch with Padampura Temple. Find our address, phone numbers, email, and how to reach us by road, rail, or air. Visit the sacred Jain pilgrimage site." />
        <meta name="keywords" content="Padampura Temple Contact, How to Reach Padampura, Jain Temple Address, Temple Phone Number, Jain Pilgrimage, Nearby Places" />
        <meta name="author" content="Padampura Temple Administration" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Social Sharing */}
        <meta property="og:title" content="Contact Us - Padampura Temple" />
        <meta property="og:description" content="Find contact details and directions to Padampura Temple, a revered Jain pilgrimage destination." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://padampuraji.in/contact" />
        <meta property="og:site_name" content="Padampura Temple" />
        <meta property="og:image" content="https://padampuraji.in/logo192.png" />
        <meta property="og:image:alt" content="Official logo of Padampura Jain Temple" />

        {/* Canonical URL */}
        <link rel="canonical" href="https://padampuraji.in/contact" />

        {/* Structured Data (JSON-LD) */}
        {contData && (
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Place",
              "name": "Padampura Temple",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": splitLines(contData.Contact_Address)[0] || "Bada Padampura Jain Temple",
                "addressLocality": "Sawai Madhopur",
                "addressRegion": "Rajasthan",
                "postalCode": "322021",
                "addressCountry": "IN"
              },
              "telephone": splitLines(contData.Contact_PhoneNumbers)[0]?.trim() || "+91 XXXXXXXXXX",
              "email": contData.Contact_EmailIDs || "info@padampuraji.in",
              "url": "https://padampuraji.in/contact",
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 26.727618934418555,
                "longitude": 75.94241565889554
              },
              "description": "Sacred Jain pilgrimage site dedicated to Lord Parshvanath."
            })}
          </script>
        )}
      </Helmet>

      {/* Hero Section with Map */}
      <div className='mt-5 pt-2'>
        <div className='container'>
          <h1 className='text-center text-decoration-underline my-4' style={{
            color: "#DC7633",
            fontFamily: "Poppins",
            fontWeight: 500,
            fontSize: "20px"
          }}>
            Contact Us
          </h1>

          <div className='row'>
            {/* Google Map */}
            <div className='col-lg-7 col-md-6 col-sm-12'>
              <div className="card rounded-1 border-0">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3563.73239400511!2d75.91925277449764!3d26.720994868305045!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396dc53071f2920b%3A0x72a52e0294847887!2sBada%20padampura%20jain%20temple!5e0!3m2!1sen!2sin!4v1714049424665!5m2!1sen!2sin"
                  width="100%"
                  height="350"
                  title="Location of Padampura Jain Temple on Google Maps"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>

            {/* Contact Info */}
            <div className='col-lg-5 col-md-6 col-sm-12'>
              <div className='card contact_info_sec'>
                {/* Phone */}
                <div className='d-flex'>
                  <div className='text-center p-2' style={{ width: "100%", borderRight: "1px solid #D5D8DC" }}>
                    <IoCall style={{ color: "#E74C3C" }} />
                    <div style={{
                      color: "#DC7633",
                      fontFamily: "Poppins",
                      fontWeight: 500,
                      fontSize: "14px"
                    }}>
                      CONTACT US
                    </div>
                  </div>
                  <div className='text-start p-2' style={{ width: "100%" }}>
                    {splitLines(contData?.Contact_PhoneNumbers).map((phone, i) => (
                      <div key={i} style={{
                        color: "#2C3E50",
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "14px"
                      }}>
                        {phone.trim()}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Address */}
                <div className='d-flex mt-4'>
                  <div className='text-center p-2' style={{ width: "100%", borderRight: "1px solid #D5D8DC" }}>
                    <FaLocationDot style={{ color: '#DC7633', fontSize: "16px" }} />
                    <div style={{
                      color: "#DC7633",
                      fontFamily: "Poppins",
                      fontWeight: 500,
                      fontSize: "14px"
                    }}>
                      ADDRESS
                    </div>
                  </div>
                  <div className='text-start p-2' style={{ width: "100%" }}>
                    {splitLines(contData?.Contact_Address).map((addr, i) => (
                      <div key={i} style={{
                        color: "#2C3E50",
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "14px"
                      }}>
                        {addr.trim()}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Email */}
                <div className='d-flex mt-4'>
                  <div className='text-center p-2' style={{ width: "100%", borderRight: "1px solid #D5D8DC" }}>
                    <TfiEmail style={{ color: "#E74C3C", fontSize: "20px" }} />
                    <div style={{
                      color: "#DC7633",
                      fontFamily: "Poppins",
                      fontWeight: 500,
                      fontSize: "14px"
                    }}>
                      EMAIL
                    </div>
                  </div>
                  <div className='text-start p-2' style={{ width: "100%" }}>
                    <div style={{
                      color: "#2C3E50",
                      fontFamily: "Poppins",
                      fontWeight: 500,
                      fontSize: "14px"
                    }}>
                      {contData?.Contact_EmailIDs || "info@padampuraji.in"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* How to Reach */}
        <div className='container mt-5'>
          <h2 className='text-center text-decoration-underline mt-5' style={{
            color: "#DC7633",
            fontFamily: "Poppins",
            fontWeight: 500,
            fontSize: "24px"
          }}>
            How to Reach
          </h2>
          <p style={{
            color: "#2C3E50",
            fontFamily: "Poppins",
            fontWeight: 400,
            fontSize: "15px"
          }}>
            {contData?.Reach_Description || "Learn how to reach Padampura Jain Temple via road, rail, or air."}
          </p>

          <h3 style={{
            color: "#2C3E50",
            fontFamily: "Poppins",
            fontWeight: 500,
            fontSize: "18px"
          }}>Road Way</h3>
          <div style={{
            color: "#2C3E50",
            fontFamily: "Poppins",
            fontWeight: 400,
            fontSize: "14px"
          }}>
            {splitLines(contData?.Reach_RoadDesc).map((desc, i) => (
              <div key={i}>{desc.trim()}</div>
            ))}
          </div>

          <h3 style={{
            color: "#2C3E50",
            fontFamily: "Poppins",
            fontWeight: 500,
            fontSize: "18px"
          }}>Rail Way</h3>
          <p style={{
            color: "#2C3E50",
            fontFamily: "Poppins",
            fontWeight: 400,
            fontSize: "14px"
          }}>
            {contData?.Reach_RailDesc}
          </p>

          <h3 style={{
            color: "#2C3E50",
            fontFamily: "Poppins",
            fontWeight: 500,
            fontSize: "18px"
          }}>Air Way</h3>
          <p style={{
            color: "#2C3E50",
            fontFamily: "Poppins",
            fontWeight: 400,
            fontSize: "14px"
          }}>
            {contData?.Reach_AirDesc}
          </p>

          <h3 style={{
            color: "#2C3E50",
            fontFamily: "Poppins",
            fontWeight: 500,
            fontSize: "18px"
          }}>Nearby Description</h3>
          <p style={{
            color: "#2C3E50",
            fontFamily: "Poppins",
            fontWeight: 400,
            fontSize: "14px"
          }}>
            {contData?.NearbyDesc}
          </p>
        </div>

        {/* Nearby Places */}
        <div className='container'>
          <h2 className='text-center text-decoration-underline my-4' style={{
            color: "#DC7633",
            fontFamily: "Poppins",
            fontWeight: 500,
            fontSize: "20px"
          }}>
            Nearby Places
          </h2>

          {loader ? (
            <div className="text-center my-4">
              <span className="loader" aria-label="Loading nearby places..."></span>
            </div>
          ) : (
            nearByData.length > 0 ? (
              nearByData.map((item, index) => (
                <div key={index} className='row mb-3'>
                  <div className='col-lg-12'>
                    <div className='card p-3 rounded-0 border-0'>
                      <div className='row'>
                        {/* Image */}
                        <div className='col-lg-4 col-md-6 col-sm-12'>
                          <img
                            src={item.PlaceImagePath || PadampuraTemple}
                            alt={item.PlaceName ? `Image of ${item.PlaceName}` : "Nearby place at Padampura"}
                            loading="lazy"
                            style={{
                              width: "100%",
                              height: "200px",
                              objectFit: "cover",
                              borderRadius: "4px"
                            }}
                          />
                        </div>

                        {/* Info */}
                        <div className='col-lg-8 col-md-6 col-sm-12 text-start'>
                          <h3 style={{
                            fontFamily: "Poppins",
                            fontSize: "24px",
                            fontWeight: 500,
                            color: "#000"
                          }}>
                            {item.PlaceName}
                          </h3>
                          <div
                            className='py-2'
                            style={{
                              fontFamily: "Poppins",
                              fontSize: "14px",
                              fontWeight: 500,
                              color: "#1f5156"
                            }}
                            dangerouslySetInnerHTML={{ __html: sanitizeHtml(item.PlaceDesc) }}
                          ></div>
                          <div className='d-flex align-items-center'>
                            <MdCall className='me-2' style={{ color: 'orangered', fontSize: '16px' }} />
                            <span style={{
                              fontFamily: "Poppins",
                              fontSize: "15px",
                              fontWeight: 500,
                              color: "#1f5156",
                              letterSpacing: "1.5px"
                            }}>
                              {item.PlaceCotactNumber}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-center" style={{ color: "#808B96" }}>
                No nearby places available.
              </p>
            )
          )}
        </div>

        {/* Scroll to Top Button */}
        <button
          className="scroll-to-top-button border-0 rounded-2"
          onClick={scrollToTop}
          aria-label="Scroll to top"
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            width: "40px",
            height: "40px",
            backgroundColor: "#E74C3C",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            boxShadow: "0 2px 10px rgba(0,0,0,0.2)"
          }}
        >
          <IoArrowUpCircleOutline style={{ fontSize: "32px" }} />
        </button>
      </div>
    </div>
  );
}